import { TOptions } from '@if/core/i18n'
import { translateErrorCode } from '@src/types'
import { DetailedHTMLProps, forwardRef, InputHTMLAttributes, LegacyRef } from 'react'
import { FieldError } from 'react-hook-form'

type Props = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  id: string
  label?: string
  type?: 'text' | 'number'
  error?: FieldError
  wrapStyle?: string
  errorParams?: TOptions
}

const InputText = forwardRef<Props, Props>(
  ({ id, error, label, wrapStyle, type = 'text', errorParams, ...otherProps }: Props, ref) => {
    return (
      <div className={`control-group ${error && 'error'}`}>
        {label && <label htmlFor={id}>{label}</label>}
        <div className={wrapStyle}>
          <input id={id} type={type} {...otherProps} ref={ref as LegacyRef<HTMLInputElement>} />
        </div>
        {error && <p className="error-message">{translateErrorCode(error, errorParams)}</p>}
      </div>
    )
  },
)

InputText.displayName = 'InputText'

export default InputText
